import { ReactNode } from 'react';

export enum Game {
  RPS = 'RPS', // 가위바위보
  MRT = 'MRT', // 도형 회전하기
  PM = 'PM', // 약속 정하기
  RMT = 'RMT', // 길 만들기
  PCT2 = 'PCT2', // 마법약 만들기
  OTN = 'OTN', // 숫자 누르기
  FNB = 'FNB', // 도형 순서 기억하기
  HAS = 'HAS', // 고양이 술래잡기
  WNC = 'WNC', // 개수 비교하기
}

export const gameTypeStringMap: Record<GameType, ReactNode> = {
  RPS: '가위바위보',
  MRT: '도형 회전하기',
  PM: '약속 정하기',
  RMT: '길 만들기',
  PCT2: '마법약 만들기',
  OTN: '숫자 누르기',
  FNB: (
    <>
      도형 순서 <br /> 기억하기
    </>
  ),
  HAS: '고양이 술래잡기',
  WNC: '개수 비교하기',
};

export const gameTypeUnreliableCommentMap: Record<GameType, string> = {
  MRT: '도형 회전하기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 목표에 맞게 도형 회전 과정을 만들었는지, 최소한의 버튼만 사용했는지 점검해 보세요.',
  RPS: '가위바위보의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 어떤 관점에서 가위바위보를 해야 하는지, 키보드의 방향 키를 잘 확인했는지 점검해 보세요.',
  PM: '약속 정하기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 주어진 질문에 맞게 응답했는지, 응답 시간을 준수했는지 점검해 보세요.',
  RMT: '길 만들기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 정답 울타리 개수에 맞게 울타리를 설치했는지, 모든 교통수단이 목적지에 맞게 도착했는지 점검해 보세요.',
  PCT2: '마법약 만들기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 같은 약초 조합이라도 때에 따라 다른 색의 마법약이 만들어질 수 있어요. 해당 조합에서 가장 자주 만들어지는 마법약의 색을 기억해서 응답하였는지 점검해 보세요.',
  FNB: '도형 순서 기억하기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 도형을 제시된 순서대로 정확하게 기억해서 응답했는지, 제한 시간 내에 응답을 잘 했는지 점검해 보세요.',
  OTN: '숫자 누르기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 주어진 규칙에 맞게 잘 응답했는지 점검해 보세요.',
  WNC: '개수 비교하기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 개수가 더 많은 단어를 잘 선택했는지, 제한 시간 내에 응답을 잘 제출했는지 점검해 보세요.',
  HAS: '고양이 술래잡기의 방법을 잘 이해하지 못했거나 게임의 목표와 다른 방식으로 응답을 했을 가능성이 있어요. 생쥐와 고양이의 위치를 잘 기억해서 응답했는지, 확신하는 정도를 솔직하게 응답했는지 점검해 보세요.',
};

export type GameType = keyof typeof Game;
